<section class="navigation">
  <div >
    <div class="brand">
        <a href="/homePage">
            <span style="font-size: 18px !important; font-weight: 900; color: var(--main-color);">MyPBC Portal</span>
        </a>
    </div>
    <nav>
      <div class="nav-mobile">
        <a id="nav-toggle" (click)="toggle()">
        <span></span>
      </a>
      </div>
      <ul class="nav-list">
        <li>
          <a *ngIf="isUserSignedIn==true" [routerLink]="'/homePage'" routerLinkActive="active">Home</a>
        </li>
        <li>
          <a *ngIf="isUserSignedIn==true" [routerLink]="'/businessProcess'" routerLinkActive="active">My PBC Profile</a>
        </li>
        <li>
          <a [routerLink]="'/contact'" routerLinkActive="active">Contact Us</a>
        </li>       
        <li>
          <a [routerLink]="'/help'" routerLinkActive="active">Help</a>
        </li>      
        <li>
          <a *ngIf="isUserSignedIn==true" (click)="logoutViaModal()">Logout</a>
        </li>
      </ul>
    </nav>
  </div>
</section>